import { push } from 'react-router-redux';
import * as actionTypes from './actionTypes';
import {
  JWTOKEN,
  STAFFID,
  STDBIDSESSION_ID,
  CATEGORY_ID,
  STATION_ID
} from './../constants';

export const fetchStaffLoginRequest = () => ({
  type: actionTypes.FETCH_STAFF_LOGIN_REQUEST
});
export const fetchStaffLoginFailure = message => ({
  type: actionTypes.FETCH_STAFF_LOGIN_FAILURE,
  message
});
export const fetchStaffLoginSuccess = login => ({
  type: actionTypes.FETCH_STAFF_LOGIN_SUCCESS,
  login
});
export const fetchSuccess = adminuser => ({
  type: actionTypes.FETCH_SUCCESS,
  allstaffs
});
export const fetchFailure = message => ({
  type: actionTypes.FETCH_FAILURE,
  message
});
export function redirect(path) {
  return dispatch => {
    dispatch(push(path));
  };
}

export function fetchAllStaff() {
  return dispatch =>
    fetch(`api/employees/all-employees`)
      .then(res => res.json())
      .then(json => {
        return json;
      });
}

export function getUserInformation(staffId) {
  return () => {
    const userRequestUrl = `employees/${staffId}`;
    return fetch(`/api/${userRequestUrl}`, {
      method: 'GET'
    })
      .then(res => res.json())
      .then(json => {
        return json;
      });
  };
}

export const fetchStaffLogin = (username, password) => {
  return dispatch => {
    let access_token = null;
    fetch('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({
        staffId: username,
        password: password
      })
    })
      .then(res => res.json())
      .then(json => {
        const { token, user } = json;
        access_token = JSON.stringify({ token: token });

        fetch(`/api/employees/${username}`)
          .then(res => res.json())
          .then(json2 => {
            sessionStorage.setItem(JWTOKEN, access_token);
            sessionStorage.setItem(STAFFID, json2.staffId);

            sessionStorage.setItem(STDBIDSESSION_ID, user.standingBidSessionId || null);
            sessionStorage.setItem(
              CATEGORY_ID,
              user.currentCategory.categoryId || null
            );
            sessionStorage.setItem(
              STATION_ID,
              user.currentCategory.stationId || null
            );
            dispatch(push('home'));
            return dispatch(fetchStaffLoginSuccess({ access_token, user }));
          });
      });
  };
};
